const SCREEN_STATES = {
    CHOOSE: "CHOOSE",
    ENTER: "ENTER",
  };

  export default SCREEN_STATES;